import React from 'react';
import PropTypes from 'prop-types';
import { NoCreditChecks, LikeIcon, ExpertSupport, BestDealsPrice } from '../../../images';
import EarthlinkPerksExisting from './EarthlinkPerksExisting';
import { useServiceablitityData, useCallCenterFlag } from '../../../hooks/order';
import EarthlinkPerksCTA from './EarthlinkPerksCTA';
import { useTranslation } from 'react-i18next';

const EarthlinkPerks = (props) => {
  const { phoneNumber, perkItems, title, subtitle, ctaTitle, ctaFooterText } = props;
  const { t } = useTranslation();
  const { isExistingCustomer: isExisting, fixedWirelessProducts } = useServiceablitityData();
  const { isAfterHours } = useCallCenterFlag();
  const hasWhiPlans = fixedWirelessProducts?.length > 0;

  const DEFAULT_PERK_ITEMS = [
    { title: t('products.perkNoCreditTitle'), desc: t('products.perkNoCreditDesc'), icon: NoCreditChecks },
    { title: t('products.perkNoBundlesTitle'), desc: t('products.perkNoBundlesDesc'), icon: LikeIcon },
    { title: t('products.perkExpertTitle'), desc: t('products.perkExpertDesc'), icon: ExpertSupport },
    { title: t('products.perkDealsTitle'), desc: t('products.perkDealsDesc'), icon: BestDealsPrice },
  ];

  const itemsToRender = perkItems || DEFAULT_PERK_ITEMS;
  const headingTitle = title || (isAfterHours ? t('products.promiseTitleAfterHours') : (isExisting ? t('products.promiseTitleExisting') : t('products.promiseTitleReady')));
  const headingSubtitle = subtitle || (isExisting ? t('products.promiseSubtitleExisting') : t('products.promiseSubtitleNew'));

  return (
    <section className="perks-below-slider">
      <div className="elink-container">
        <div className="perks-below-slider__heading">
          <h2 className="perks-below-slider__title">
            {headingTitle}
          </h2>
          <p className="perks-below-slider__subtitle">
            {headingSubtitle}
          </p>
        </div>

        <div className="perks-below-slider__grid">
          {itemsToRender.map(({ title: perkTitle, desc, icon }) => (
            <div key={perkTitle} className="perks-below-slider__item">
              <div className="perks-below-slider__iconWrap" aria-hidden="true">
                <img src={icon} alt={perkTitle} />
              </div>
              <h3 className="perks-below-slider__itemTitle">{perkTitle}</h3>
              <p className="perks-below-slider__itemDesc">{desc}</p>
            </div>
          ))}
        </div>

        {hasWhiPlans || isAfterHours || !isExisting ? (
          <EarthlinkPerksCTA
            phoneNumber={phoneNumber}
            title={ctaTitle}
            footerText={ctaFooterText}
          />
        ) : (
          <EarthlinkPerksExisting phoneNumber={phoneNumber} />
        )}
      </div>
    </section>
  );
};

EarthlinkPerks.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  perkItems: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    desc: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
  })),
  title: PropTypes.string,
  subtitle: PropTypes.string,
  ctaTitle: PropTypes.string,
  ctaFooterText: PropTypes.string,
};

export default EarthlinkPerks;
